import BusinessJobsDirectories from 'pages/business-jobs'
export default BusinessJobsDirectories
